
export default {
    SET_SUBSCRIPTION (state, subscriptions) {
        state.subscriptions = subscriptions
    },
    SET_INFO_DB(state, payload){
        state.infoDB = payload
    },
    UPDATE_SUBSCRIPTION(state, payload){
        const index = state.subscriptions.findIndex(subscription => subscription.id == payload.id);
        state.subscriptions.splice(index, 1, payload)
    }
}